import { render, staticRenderFns } from "./transactionFlowPendingComponent.vue?vue&type=template&id=3be3771d&scoped=true&"
import script from "./transactionFlowPendingComponent.vue?vue&type=script&lang=js&"
export * from "./transactionFlowPendingComponent.vue?vue&type=script&lang=js&"
import style0 from "./transactionFlowPendingComponent.vue?vue&type=style&index=0&id=3be3771d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be3771d",
  null
  
)

export default component.exports